/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
import { User } from '../../modules/core/users'
import { useAuth } from '../../modules/auth'
import clsx from 'clsx'

type Props = {
  user: User
}

const ReviewUserCell: FC<Props> = ({user}) => {

  const { currentUser } = useAuth();

  if (! (user)) {
    return <></>
  }

  return (        
  <div className={clsx( 'f-7', {'fw-bold text-danger': (currentUser && currentUser.id === user.id)}, )} >
    {user.name}
  </div>
  )
}

export {ReviewUserCell}